import { useMemo, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import api from '../services/api'

export default function VerifyEmail() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const initialEmail = useMemo(() => (searchParams.get('email') || '').trim(), [searchParams])

  const [email, setEmail] = useState(initialEmail)
  const [code, setCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  async function handleVerify(e) {
    e.preventDefault()
    setError('')
    setMessage('')
    setLoading(true)
    try {
      await api.post('/auth/verify', { email, code })
      setMessage('Email verificado correctamente. Ya puedes iniciar sesión.')
      setTimeout(() => navigate('/login'), 1200)
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo verificar el código')
    } finally {
      setLoading(false)
    }
  }

  async function handleResend() {
    setError('')
    setMessage('')
    setLoading(true)
    try {
      await api.post('/auth/resend-verification', { email })
      setMessage('Te hemos enviado un nuevo código al correo.')
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo reenviar el código')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-game-dark">
      <div className="max-w-md w-full p-8 bg-gray-900 rounded-lg shadow-xl border border-gray-800">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-game-primary">TerranWar</h1>
          <p className="text-sm text-gray-400 mt-1">Proyecto-V</p>
        </div>

        <h2 className="text-xl text-center text-gray-300 mb-6">Verificar Email</h2>

        {error && <div className="mb-4 p-3 bg-red-900/50 border border-red-500 rounded-lg text-red-200 text-sm">{error}</div>}
        {message && <div className="mb-4 p-3 bg-green-900/50 border border-green-500 rounded-lg text-green-200 text-sm">{message}</div>}

        <form onSubmit={handleVerify} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-game-primary"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-400 mb-1">Código (4 dígitos)</label>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 4))}
              required
              maxLength={4}
              disabled={loading}
              className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-center text-2xl tracking-widest focus:outline-none focus:ring-2 focus:ring-game-primary"
              placeholder="0000"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-game-primary text-game-dark font-bold py-2 px-4 rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Verificando...' : 'Verificar código'}
          </button>
        </form>

        <button
          type="button"
          onClick={handleResend}
          disabled={loading || !email}
          className="w-full mt-3 border border-game-primary text-game-primary font-bold py-2 px-4 rounded-lg hover:bg-game-primary/10 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Reenviar código
        </button>

        <div className="mt-6 text-center">
          <Link to="/login" className="text-game-primary hover:underline">Volver a login</Link>
        </div>
      </div>
    </div>
  )
}
